import { render, staticRenderFns } from "./DisplayUsuario.vue?vue&type=template&id=f02e20ec"
import script from "./DisplayUsuario.vue?vue&type=script&lang=js"
export * from "./DisplayUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports